import { render, staticRenderFns } from "./ClientAboutUs.vue?vue&type=template&id=0ea57b0a&"
import script from "./ClientAboutUs.vue?vue&type=script&lang=js&"
export * from "./ClientAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports